import { compact } from "lodash";
import moment from "moment";
import { LanguageEnum } from "src/types/enum/LanguageEnum";

export enum ReservedId {
    ORGANIZATION_ID = -1,
    ALL_POSS_ID = 0,
}

export const USER_TABLE_LIMIT = 20;
export const USER_TABLE_PAGING_OPTIONS = [10, 20, 50];

export const DISPLAY_DEMO = "flynt:is-display-demo";
export const DISPLAY_DEMO_SUFFIX = "is-display-demo";

export const DOW_HOURS_SHIFT = 5;

export const EXPORT_EXCEL_PAGE_SIZE_REQUEST = 20;

export const MAX_POS_LIMIT = Number(import.meta.env.VITE_MAX_POS_LIMIT ?? 1000);

export type ScreenType =
    | "offer-agenda"
    | "offer-management"
    | "offer-performance"
    | "sponsored-ad-agenda"
    | "sponsored-ad-management"
    | "sponsored-ad-performance";

const MAX_POS_SCREENS_DEFAULT: ScreenType[] = ["offer-performance", "sponsored-ad-performance"];

export const MAX_POS_SCREENS = compact(
    (import.meta.env.VITE_MAX_POS_SCREENS ?? MAX_POS_SCREENS_DEFAULT.join(",")).split(",")
) as ScreenType[];

export const SMART_SCHEDULER_TOLERANCE = moment.duration(5, "minutes");

// i18n
export const LANGUAGE_LOCAL_STORAGE_KEY = "locale";
export const DEFAULT_LANGUAGE = LanguageEnum.FR;

// Breakpoints
export enum Breakpoint {
    XS = 0,
    SM = 600,
    MD = 900,
    LG = 1280,
    XL = 1440,
}

// Temporary limit for exports
export const MAX_EXPORT_ROWS_OFFER = Number(import.meta.env.VITE_MAX_EXPORT_ROWS_OFFER) || 1000000;
export const MAX_EXPORT_ROWS_AD = Number(import.meta.env.VITE_MAX_EXPORT_ROWS_AD) || 1000000;
